import React from 'react';
import { Box, Group, Text } from '@mantine/core';
import { DatePickerInput, TimePicker } from '@mantine/dates';
import { UseFormReturnType } from '@mantine/form';
import { IconClock } from '@tabler/icons-react';
import dayjs from 'dayjs';

import { RequestSurveyFormValues } from './types';

type Props = {
    form: UseFormReturnType<RequestSurveyFormValues>;
};

function RequestSurveyDueDateFields({ form }: Props) {
    const todayStart = dayjs().startOf('day').toDate();
    const isDueDateToday = Boolean(
        form.values.dueDate &&
            dayjs(form.values.dueDate).isSame(dayjs(), 'day'),
    );
    const minTime = isDueDateToday ? dayjs().format('HH:mm:ss') : undefined;

    return (
        <Box>
            <Text size="16px" mb={4}>
                Due Date
            </Text>
            <Group grow align="flex-start">
                <Box>
                    <Text size="sm" c="#ACB5BD" fw={300} mb={4}>
                        Date
                    </Text>
                    <DatePickerInput
                        placeholder={`00/00/${dayjs().year()}`}
                        size="md"
                        radius="lg"
                        variant="default"
                        minDate={todayStart}
                        {...form.getInputProps('dueDate')}
                    />
                </Box>
                <Box>
                    <Text size="sm" c="#ACB5BD" fw={300} mb={4}>
                        Time
                    </Text>
                    <TimePicker
                        leftSection={<IconClock size={16} />}
                        placeholder="--:--"
                        size="md"
                        radius="lg"
                        variant="default"
                        withDropdown
                        className="flex-1"
                        {...form.getInputProps('dueTime')}
                        min={minTime}
                    />
                </Box>
            </Group>
        </Box>
    );
}

export default RequestSurveyDueDateFields;
